import { render, staticRenderFns } from "./MServHouseComp.vue?vue&type=template&id=4b7dec36&"
import script from "./MServHouseComp.vue?vue&type=script&lang=js&"
export * from "./MServHouseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports